// extracted by mini-css-extract-plugin
module.exports = {"progress":"src-views-common-progressbar-index-module__progress--2sO05"};